import {useEffect} from "react";
import {useLexicalComposerContext} from "@lexical/react/LexicalComposerContext";
import {
    COMMAND_PRIORITY_HIGH,
    PASTE_COMMAND,
    $getSelection,
    $isRangeSelection,
    $createParagraphNode,
    $createTextNode,
} from "lexical";

const PlainTextPastePlugin = () => {
    const [editor] = useLexicalComposerContext();

    useEffect(() => {
        return editor.registerCommand(
            PASTE_COMMAND,
            (event: ClipboardEvent | null) => {
                if (!event) return false;

                const dt = event.clipboardData;
                if (!dt) return false;

                const text = dt.getData("text/plain");
                if (!text) return false;

                // Jeśli to wygląda na JSON stanu Lexicala – nie ruszaj (pozwól innym handlerom)
                try {
                    const parsed = JSON.parse(text);
                    if (parsed && typeof parsed === "object" && "root" in parsed) {
                        return false;
                    }
                } catch {}

                event.preventDefault();

                editor.update(() => {
                    const selection = $getSelection();
                    if (!$isRangeSelection(selection)) return;

                    // Normalizacja końców linii
                    const lines = text.replace(/\r\n?/g, "\n").split("\n");

                    // Usuń zaznaczenie i wstaw paragrafy
                    selection.removeText();

                    const nodes = lines.map((line) => {
                        const p = $createParagraphNode();
                        // nawet pusta linia ma zostać jako pusty paragraf
                        if (line.length > 0) {
                            p.append($createTextNode(line));
                        }
                        return p;
                    });

                    selection.insertNodes(nodes);
                });

                return true;
            },
            COMMAND_PRIORITY_HIGH
        );
    }, [editor]);

    return null;
};

export default PlainTextPastePlugin;
